import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { ref, unref, onMounted, nextTick, onBeforeUnmount, watch } from 'vue-demi';
const { useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv?.() || {};

export default function useSwiper({ el, paginationEl, options }) {
    const swiperIns = ref(null);

    const initSwiper = () => {
        const [$el, $paginationEl, opts] = [unref(el), unref(paginationEl), unref(options)];

        const { loop, autoplay, autoplayDelay, slidesPerView, spaceBetween, slides, centeredSlides } = opts;

        // 无内容不初始化
        if (!slides.length) {
            return;
        }

        // 延迟时间（提供是配置单位是s）
        const delay = autoplayDelay * 1000;

        swiperIns.value = new Swiper($el, {
            modules: [Autoplay, Pagination],
            loop,
            centeredSlides,
            slidesPerView,
            spaceBetween,
            autoplay: autoplay && { delay, disableOnInteraction: false },
            // 视觉规范定600
            speed: 600,
            pagination: {
                el: $paginationEl,
                clickable: true
            }
        });
    };

    const destroySwiper = () => {
        swiperIns.value?.destroy();
    };

    watch(options, () => {
        destroySwiper();
        nextTick(initSwiper);
    });

    onMounted(() => {
        !isPreRender && initSwiper();
    });

    onBeforeUnmount(() => {
        destroySwiper();
    });

    return {
        swiper: swiperIns
    };
}
